var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercardLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 23,
    viewBox: "0 0 33 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.953125,
    y: 0.208984,
    width: 31.9917,
    height: 22.5823,
    rx: 2.82279,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2556 17.5509C24.7793 17.5509 27.6358 14.7284 27.6358 11.2466C27.6358 7.76489 24.7793 4.94238 21.2556 4.94238C19.6765 4.94238 18.2313 5.50928 17.1172 6.44836C16.0031 5.50933 14.5579 4.94246 12.9788 4.94246C9.45513 4.94246 6.59863 7.76496 6.59863 11.2467C6.59863 14.7284 9.45513 17.5509 12.9788 17.5509C14.558 17.5509 16.0031 16.984 17.1173 16.045C18.2314 16.984 19.6765 17.5509 21.2556 17.5509Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1172 16.0449C18.4891 14.8886 19.359 13.168 19.359 11.2466C19.359 9.32524 18.4891 7.60462 17.1172 6.44831C18.2313 5.50926 19.6764 4.94238 21.2556 4.94238C24.7793 4.94238 27.6358 7.76489 27.6358 11.2466C27.6358 14.7284 24.7793 17.5509 21.2556 17.5509C19.6764 17.5509 18.2313 16.984 17.1172 16.0449Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1177 16.0449C18.4896 14.8886 19.3595 13.1679 19.3595 11.2466C19.3595 9.32518 18.4896 7.60456 17.1177 6.44824C15.7459 7.60456 14.876 9.32518 14.876 11.2466C14.876 13.1679 15.7459 14.8886 17.1177 16.0449Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardLogoDark);
export default __webpack_public_path__ + "static/media/mastercard-logo-dark.d7da0875b869312228afbb33e41c531e.svg";
export { ForwardRef as ReactComponent };